import { addHours } from "date-fns";

import { formatDate } from "../lib/date";

import BaseModel from "./base-model";
import Spot from "./Spot";

export const DELIVERY_STATUS_0 = "DELIVERY_STATUS_RECEIPT";
export const DELIVERY_STATUS_1 = "DELIVERY_STATUS_PICKUP_SCHEDULED";
export const DELIVERY_STATUS_2 = "DELIVERY_STATUS_PICKUP_COMPLETED";
export const DELIVERY_STATUS_3 = "DELIVERY_STATUS_WAREHOUSED"; // 입고 | 배송대기
export const DELIVERY_STATUS_4 = "DELIVERY_STATUS_DELIVERY_STARTED"; // 배송출발
export const DELIVERY_STATUS_5 = "DELIVERY_STATUS_DELIVERED";
export const DELIVERY_STATUS_6 = "DELIVERY_STATUS_DELIVERY_SENT_BACK";
export const DELIVERY_STATUS_7 = "DELIVERY_STATUS_DELIVERY_LOST";
export const DELIVERY_STATUS_8 = "DELIVERY_RIDER_ALLOCATED"; // 배송대기
export const DELIVERY_STATUS_9 = "ADDRESS_NOT_SUPPORTED";
export const DELIVERY_STATUS_10 = "ACCIDENT";
export const DELIVERY_STATUS_11 = "CANCELED";
export const DELIVERY_STATUS_12 = "DELIVERY_POSTPONED"; // 배송연기

// export const STATUS_PICKUP = "PICKUP";
// export const STATUS_PICKUP_COMPLETED = "PICKUP_COMPLETED"; // 수거 완료
// export const STATUS_DELIVERY_WAITING = "DELIVERY_WAITING"; // 배송배차
// export const STATUS_DELIVERY_POSTPONED = "DELIVERY_POSTPONED"; // 배송연기
// export const STATUS_DELIVERY_STARTED = "DELIVERY_STARTED"; // 배송출발
// export const STATUS_DELIVERY_ALLOCATED = "DELIVERY_ALLOCATED";
// export const STATUS_COMPLETED = "DELIVERED";
// export const STATUS_SENT_BACK = "SENT_BACK";
// export const STATUS_LOST = "LOST";
// export const STATUS_ADDRESS_NOT_SUPPORTED = "ADDRESS_NOT_SUPPORTED";

export const STATUS_PICKUP_FOR_COUNT = "pickup-scheduled";
export const STATUS_DELIVERY_ALLOCATED_FOR_COUNT = "delivery-allocated";
export const STATUS_DELIVERY_WAITING_FOR_COUNT =
  "delivery-allocated-before-start";
export const STATUS_DELIVERY_POSTPONED_FOR_COUNT = "delivery-postponed";
export const STATUS_DELIVERY_STARTED_FOR_COUNT = "delivery-started";
export const STATUS_DELIVERED_FOR_COUNT = "delivered";

export const DELIVERY_TYPE_NORMAL = "1";
export const DELIVERY_TYPE_PICKUP = "2";
export const DELIVERY_TYPE_RETURN = "3";
export const DELIVERY_TYPE_PICKUP_RETURN = "2,3";

export const ADDRESS_API_TYPE_ONE = "SOOJIONE";
export const ADDRESS_API_TYPE_KAKAO = "KAKAO";

export const SPOT_CODE_FRESHCODE = "P0020"; // 프레시코드 spot code
export const SPOT_CODE_10585 = "10585"; // CJ더마켓
export const SPOT_CODE_10625 = "10625"; // 올리브영퀵커머스

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function getDistance(lat1, lng1, lat2, lng2) {
  let R = 6371; // Radius of the earth in km
  let dLat = deg2rad(lat2 - lat1); // deg2rad below
  let dLon = deg2rad(lng2 - lng1);
  let a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c; // Distance in km

  return Math.round(d * 1000);
}

function getPointToArray(point) {
  if (point && point.indexOf("POINT") > -1) {
    let pointArray = point.substring(6, point.length - 1).split(" ");

    return pointArray;
  } else {
    return [0, 0];
  }
}

export const parseDeliveryStatus = (status) => {
  switch (Number(status)) {
    case 0:
      return DELIVERY_STATUS_0;
    case 1:
      return DELIVERY_STATUS_1;
    case 2:
      return DELIVERY_STATUS_2;
    case 3:
      return DELIVERY_STATUS_3;
    case 4:
      return DELIVERY_STATUS_4;
    case 5:
      return DELIVERY_STATUS_5;
    case 6:
      return DELIVERY_STATUS_6;
    case 7:
      return DELIVERY_STATUS_7;
    case 8:
      return DELIVERY_STATUS_8;
    case 9:
      return DELIVERY_STATUS_9;
    case 10:
      return DELIVERY_STATUS_10;
    case 11:
      return DELIVERY_STATUS_11;
    case 12:
      return DELIVERY_STATUS_12;
    default:
      return "알수없음";
  }
};

export default class Delivery extends BaseModel {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);

    this.receiverDong = props.receiverDongObj?.name || props.receiverDong;
    this.senderDong = props.senderDongObj?.name || props.senderDong;
    this.status = parseDeliveryStatus(props.status);
    this.statusNubmer = props.status;
    this.spot = props.spot ? new Spot(props.spot) : null;
  }

  get addressApiType() {
    return this.etc4Obj ? this.etc4Obj.addressApiType : "";
  }

  get cancelableAddressNotSupported() {
    return (
      ((this.statusWaiting && this.addressNotSupported) ||
        this.statusAddressNotSupported) &&
      !this.nonDoobalType
    );
  }

  get compareReceiverLocation() {
    return {
      longitude: getPointToArray(this.receiverPoint)[0],
      latitude: getPointToArray(this.receiverPoint)[1],
    };
  }

  get compareSenderLocation() {
    return {
      longitude: getPointToArray(this.senderPoint)[0],
      latitude: getPointToArray(this.senderPoint)[1],
    };
  }

  get completedImage() {
    return (
      this.signImageLocation ||
      this.notReceivedImageLocation ||
      this.signImageLocationOnEtc ||
      this.notReceivedImageLocationOnEtc
    );
  }

  get completedLocation() {
    return this.etc4Obj ? this.etc4Obj.completedLocation : "";
  }

  get customerAddress() {
    return this.etc4Obj ? this.etc4Obj.customerAddress : null;
  }
  get customerAddressDetail() {
    return this.etc4Obj ? this.etc4Obj.customerAddressDetail : "";
  }

  get customerAddressEng() {
    return this.etc4Obj ? this.etc4Obj.customerAddressEng : "";
  }

  get customerAddressEngGpt() {
    return this.etc4Obj ? this.etc4Obj.customerAddressEngGpt : "";
  }

  get deliveryDoneLatitude() {
    return this.etc4Obj ? this.etc4Obj.deliveryDoneLatitude : "";
  }

  get deliveryDoneLongitude() {
    return this.etc4Obj ? this.etc4Obj.deliveryDoneLongitude : "";
  }

  get deliveryLostLatitude() {
    return this.etc4Obj ? this.etc4Obj.deliveryLostLatitude : "";
  }

  get deliveryLostLongitude() {
    return this.etc4Obj ? this.etc4Obj.deliveryLostLongitude : "";
  }

  get deliveryPlace() {
    return this.etc4Obj ? this.etc4Obj.deliveryPlace : "";
  }

  get deliveryPlacedTime() {
    return this.etc4Obj ? this.etc4Obj.deliveryPlacedTime : "";
  }

  get deliverySentBackLatitude() {
    return this.etc4Obj ? this.etc4Obj.deliverySentBackLatitude : "";
  }

  get deliverySentBackLongitude() {
    return this.etc4Obj ? this.etc4Obj.deliverySentBackLongitude : "";
  }

  get displayAddress() {
    if (this.unrefinedAddress) {
      return this.unrefinedAddress;
    } else if (this.customerAddress) {
      return `${this.customerAddress}${
        this.customerAddressDetail &&
        this.customerAddressDetail !== this.customerAddress
          ? `, ${this.customerAddressDetail}`
          : ""
      }`;
    } else {
      return `${this.receiverAddress || this.receiverAddressRoad || ""}${
        this.receiverAddressDetail ? `, ${this.receiverAddressDetail}` : ""
      }`;
    }
  }

  get displayReceiverAddress() {
    return `${this.receiverAddress || this.receiverAddressRoad || ""}${
      this.receiverAddressDetail ? `, ${this.receiverAddressDetail}` : ""
    }`;
  }

  get displaySenderAddress() {
    return `${this.senderAddress || this.senderAddressRoad || ""}${
      this.senderAddressDetail ? `, ${this.senderAddressDetail}` : ""
    }`;
  }

  get displayUnrefinedAddressWithSender() {
    if (this.typePickupReturn) {
      if (this.unrefinedAddress) {
        return this.unrefinedAddress;
      } else if (this.customerAddress) {
        return `${this.customerAddress}${
          this.customerAddressDetail &&
          this.customerAddressDetail !== this.customerAddress
            ? `, ${this.customerAddressDetail}`
            : ""
        }`;
      } else {
        return `${this.senderAddress || this.senderAddressRoad || ""}${
          this.senderAddressDetail ? `, ${this.senderAddressDetail}` : ""
        }`;
      }
    } else {
      return `${this.senderAddress || this.senderAddressRoad || ""}${
        this.senderAddressDetail ? `, ${this.senderAddressDetail}` : ""
      }`;
    }
  }

  get distanceRefineToLimitedRefined() {
    if (this.soojioneLimitedCustomized?.point && this.receiverPoint) {
      return getDistance(
        Number(this.compareReceiverLocation.latitude),
        Number(this.compareReceiverLocation.longitude),
        Number(this.soojioneLimitedCustomizedLngLat.latitude),
        Number(this.soojioneLimitedCustomizedLngLat.longitude),
      );
    } else {
      return null;
    }
  }

  get etc4Obj() {
    try {
      return this.etc4 && JSON.parse(this.etc4);
    } catch (e) {
      return {};
    }
  }

  get freshBarcode() {
    return this.etc4Obj ? this.etc4Obj.freshBarcode : "";
  }

  get frontdoorPassword() {
    if (this.frontdoorPasswordByClient) {
      return `${this.frontdoorPasswordByClient} ${
        this.frontdoorPasswordByCorp ? `/ ${this.frontdoorPasswordByCorp}` : ""
      }`;
    } else {
      return this.frontdoorPasswordByCorp || null;
    }
  }

  get frontdoorPasswordByClient() {
    return this.etc4Obj ? this.etc4Obj.frontdoorPasswordByClient : "";
  }

  get frontdoorPasswordByCorp() {
    return this.etc4Obj ? this.etc4Obj.frontdoorPasswordByCorp : "";
  }

  get gatheredDeliveries() {
    return this.etc4Obj?.gatheredDeliveries || [];
  }

  get isConvenienceBarcode() {
    return (
      this.status === DELIVERY_STATUS_4 &&
      this.spot?.code === SPOT_CODE_FRESHCODE &&
      this.freshBarcode
    );
  }

  get isHighPrice() {
    return (
      this.statusDelivery &&
      (this.productPrice >= 200000 || this.spotLuxuryAvailable)
    );
  }

  get isLimitedHours() {
    return (
      (this.status === DELIVERY_STATUS_3 ||
        this.status === DELIVERY_STATUS_4 ||
        this.status === DELIVERY_STATUS_8 ||
        this.status === DELIVERY_STATUS_12) &&
      this.limitedDeliveryHours > 0
    );
  }

  get isNotFreshCode() {
    return this.spot?.code !== SPOT_CODE_FRESHCODE;
  }

  get isReceiverAddressError() {
    return (
      !this.receiverPoint || !this.receiverAddress || !this.receiverAddressRoad
    );
  }

  get isRequiredDelayMessage() {
    return (
      (this.status === DELIVERY_STATUS_12 ||
        this.status === DELIVERY_STATUS_4) &&
      Number(formatDate(new Date(), "HH")) > 21 &&
      (!this.delayedDeliveries || this.delayedDeliveries.length === 0)
    );
  }

  get isSenderAddressError() {
    return !this.senderPoint || !this.senderAddress || !this.senderAddressRoad;
  }

  get isTranslated() {
    return this.translatedResultOpenai || this.translatedResultPapago;
  }

  get isTranslatedChatGpt() {
    return (
      this.translatedPlatform &&
      this.translatedPlatform.toUpperCase() === "OPENAI"
    );
  }

  get limitedDeliveryAt() {
    return this.pickupDateCompleted && this.limitedDeliveryHours > 0
      ? addHours(new Date(this.pickupDateCompleted), this.limitedDeliveryHours)
      : null;
  }

  get limitedDeliveryHours() {
    return this.spot
      ? this.spot.limitedDeliveryHours
      : this.etc4Obj
        ? this.etc4Obj.limitedDeliveryHours
        : null;
  }

  get memo() {
    if (this.deliveryPlace) {
      return `(${formatDate(this.deliveryPlacedTime, "HH:mm")})${
        this.deliveryPlace
      } / ${this.memoFromCustomer || "없음"}`;
    } else {
      return this.memoFromCustomer;
    }
  }

  get mustSignature() {
    return this.etc4Obj ? this.etc4Obj.mustSignature : false;
  }

  get nonDoobalType() {
    return this.etc4Obj?.nonDoobalType;
  }

  get notReceivedImageLocationOnEtc() {
    return this.etc4Obj?.notReceivedImageLocation;
  }

  get renderProductCount() {
    return this.etc4Obj?.productCount || this.productCount;
  }

  get receiverAddressObj() {
    return this.etc4Obj ? this.etc4Obj.receiverAddressObj : null;
  }

  get receiverAddressRoadWithoutSigungu() {
    if (this.receiverAddressRoad && this.receiverSigungu) {
      return this.receiverAddressRoad.split(this.receiverSigungu)[
        this.receiverAddressRoad.split(this.receiverSigungu).length - 1
      ];
    } else if (this.receiverAddressRoad) {
      return this.receiverAddressRoad.split(" ").slice(2).join(" ");
    } else {
      return this.receiverAddressRoad;
    }
  }

  get receiverAddressWithoutSigungu() {
    if (this.receiverAddress && this.receiverSigungu) {
      return this.receiverAddress.split(this.receiverSigungu)[
        this.receiverAddress.split(this.receiverSigungu).length - 1
      ];
    } else if (this.receiverAddress) {
      return this.receiverAddress.split(" ").slice(2).join(" ");
    } else {
      return this.receiverAddress;
    }
  }

  get receiverBuilding() {
    if (this.etc4Obj.receiverBuilding) {
      return this.etc4Obj.receiverBuilding;
    } else if (this.receiverAddressObj && this.receiverAddressObj.building) {
      return this.receiverAddressObj.building;
    } else {
      return null;
    }
  }

  get receiverBuildingDongNumber() {
    if (this.receiverAddressObj && this.receiverAddressObj.buildingDongNumber) {
      return `${this.receiverAddressObj.buildingDongNumber}동`;
    } else {
      return null;
    }
  }

  get receiverBuildingHouseNumber() {
    if (
      this.receiverAddressObj &&
      this.receiverAddressObj.buildingHouseNumber
    ) {
      return `${this.receiverAddressObj.buildingHouseNumber}호`;
    } else {
      return null;
    }
  }

  get receiverBuildingDongHouseNumber() {
    if (this.receiverBuildingDongNumber && this.receiverBuildingHouseNumber) {
      return `${this.receiverBuildingDongNumber} ${this.receiverBuildingHouseNumber}`;
    } else if (
      this.receiverBuildingDongNumber ||
      this.receiverBuildingHouseNumber
    ) {
      return (
        this.receiverBuildingDongNumber || this.receiverBuildingHouseNumber
      );
    } else {
      return "건물 동/호 인식 실패";
    }
  }

  get receiverSigungu() {
    if (this.receiverAddress && this.receiverDong) {
      return this.receiverAddress.split(this.receiverDong)[0];
    } else {
      return "";
    }
  }

  get recentDelayedDelivery() {
    if (this.delayedDeliveries?.length > 0) {
      return [...this.delayedDeliveries].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      )[0];
    } else {
      return null;
    }
  }
  get refinedAddressRawResult() {
    return this.etc4Obj?.refinedAddressRawResult;
  }

  get refinedAddressRawResultError() {
    return (
      this.refinedAddressRawResult?.RCD3 === "D" ||
      this.refinedAddressRawResult?.RCD3 === "E"
    );
  }

  get refinedAfterTranslationResult() {
    return this.etc4Obj ? this.etc4Obj.refinedAfterTranslationResult : null;
  }

  get refinedAfterTranslationResultOpenai() {
    return (
      this.refinedAfterTranslationResult?.openai ||
      this.refinedAfterTranslationResult?.OPENAI ||
      null
    );
  }

  get refinedAfterTranslationResultPapago() {
    return this.refinedAfterTranslationResult?.papago || null;
  }

  get renderAddressApiType() {
    if (this.addressApiType === "TMAP") {
      return "서브1 정제:기본정제실패";
    } else if (this.addressApiType === "KAKAO") {
      return "서브2 정제:기본정제실패";
    } else if (this.addressApiType === "SOOJIONE") {
      if (this.soojioneLimitedCustomized) {
        return "입력 주소값 일치 정제";
      } else {
        return "건물명 매칭 조정정제";
      }
    } else {
      return "";
    }
  }

  get renderLimitedDeliveryAt() {
    if (this.limitedDeliveryAt) {
      return formatDate(
        this.limitedDeliveryAt,
        "MM월 dd일 HH시mm분까지 도착 보장",
      );
    } else {
      return null;
    }
  }

  get renderReceiverName() {
    let name = this.receiverName || "";

    if (name?.length > 2) {
      return name.charAt(0) + "*" + name.slice(2);
    } else {
      return name.charAt(0) + "*";
    }
  }

  get renderReceiverNameTrimmed() {
    const name = this.renderReceiverName;
    const hasKorean = /[가-힣]/.test(name);
    const maxLength = hasKorean ? 8 : 12;

    return name.length > maxLength ? name.slice(0, maxLength) + "..." : name;
  }

  get renderRefinedAddressRawResultError() {
    if (this.refinedAddressRawResult?.RCD3 === "D") {
      return "건물주의";
    } else if (this.refinedAddressRawResult?.RCD3 === "E") {
      return "도로명주의";
    } else {
      return "";
    }
  }

  get renderRequestedDeliveryTime() {
    if (this.requestedDeliveryTime) {
      if (this.spot?.code === SPOT_CODE_10625) {
        return formatDate(
          this.requestedDeliveryTime,
          "MM월 dd일 HH시mm분까지 픽업",
        );
      } else if (this.spot?.code === SPOT_CODE_10585) {
        return formatDate(
          addHours(new Date(this.requestedDeliveryTime), 1),
          "MM월 dd일 HH시mm분까지 도착 보장",
        );
      } else {
        return formatDate(
          this.requestedDeliveryTime,
          "MM월 dd일 HH시mm분까지 도착 보장",
        );
      }
    } else {
      return null;
    }
  }

  get renderRequestedDeliveryTimeForOliveQuick() {
    if (this.etc1 && this.spot?.code === SPOT_CODE_10625) {
      return formatDate(this.etc1, "MM월 dd일 HH시mm분까지 도착");
    } else {
      return null;
    }
  }

  get sendedCompletedSms() {
    return this.etc4Obj ? this.etc4Obj.sendedCompletedSms : false;
  }

  get senderAddressObj() {
    return this.etc4Obj ? this.etc4Obj.senderAddressObj : null;
  }

  get senderAddressRoadWithoutSigungu() {
    if (this.senderAddressRoad && this.senderSigungu) {
      return this.senderAddressRoad.split(this.senderSigungu)[
        this.senderAddressRoad.split(this.senderSigungu).length - 1
      ];
    } else if (this.senderAddressRoad) {
      return this.senderAddressRoad.split(" ").slice(2).join(" ");
    } else {
      return this.senderAddressRoad;
    }
  }

  get senderAddressWithoutSigungu() {
    if (this.senderAddress && this.senderSigungu) {
      return this.senderAddress.split(this.senderSigungu)[
        this.senderAddress.split(this.senderSigungu).length - 1
      ];
    } else if (this.senderAddress) {
      return this.senderAddress.split(" ").slice(2).join(" ");
    } else {
      return this.senderAddress;
    }
  }

  get senderBuilding() {
    if (this.etc4Obj?.senderBuilding) {
      return this.etc4Obj.senderBuilding;
    } else if (this.senderAddressObj && this.senderAddressObj.building) {
      return this.senderAddressObj.building;
    } else {
      return null;
    }
  }

  get senderBuildingDongNumber() {
    if (this.senderAddressObj && this.senderAddressObj.buildingDongNumber) {
      return `${this.senderAddressObj.buildingDongNumber}동`;
    } else {
      return null;
    }
  }

  get senderBuildingHouseNumber() {
    if (this.senderAddressObj && this.senderAddressObj.buildingHouseNumber) {
      return `${this.senderAddressObj.buildingHouseNumber}호`;
    } else {
      return null;
    }
  }

  get senderBuildingDongHouseNumber() {
    if (this.senderBuildingDongNumber && this.senderBuildingHouseNumber) {
      return `${this.senderBuildingDongNumber} ${this.senderBuildingHouseNumber}`;
    } else if (
      this.senderBuildingDongNumber ||
      this.senderBuildingHouseNumber
    ) {
      return this.senderBuildingDongNumber || this.senderBuildingHouseNumber;
    } else {
      return "건물 동/호 인식 실패";
    }
  }

  get senderSigungu() {
    if (this.senderAddress && this.senderDong) {
      return this.senderAddress.split(this.senderDong)[0];
    } else {
      return "";
    }
  }

  get signImageLocationOnEtc() {
    return this.etc4Obj?.signImageLocation;
  }

  get soojioneLimitedCustomized() {
    return (
      this.etc4Obj?.alteredAddressForSoojione ||
      this.etc4Obj?.soojioneLimitedCustomized
    );
  }

  get soojioneLimitedCustomizedLngLat() {
    return {
      longitude: getPointToArray(this.soojioneLimitedCustomized?.point)[0],
      latitude: getPointToArray(this.soojioneLimitedCustomized?.point)[1],
    };
  }

  get spotEtcObj() {
    try {
      return this.spot?.etc && JSON.parse(this.spot?.etc);
    } catch (e) {
      return {};
    }
  }

  get spotLuxuryAvailable() {
    return !!this.spotEtcObj?.luxuryAvailable;
  }

  get spotKurlyDrink() {
    return !!this.spotEtcObj?.kurlyDrink;
  }

  get spotName() {
    return this.spot?.name || this.senderName;
  }

  get spotDeliveredSmsActive() {
    return !!this.spot?.deliveredSmsActive;
  }

  get statusAddressNotSupported() {
    if (this.status === DELIVERY_STATUS_9) {
      if (this.deliveryRider?.id === this.newRider?.id) {
        return DELIVERY_STATUS_4;
      } else if (this.pickupRider?.id === this.newRider?.id) {
        return DELIVERY_STATUS_1;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  get statusDelivery() {
    return (
      this.status === DELIVERY_STATUS_3 ||
      this.status === DELIVERY_STATUS_4 ||
      this.status === DELIVERY_STATUS_8 ||
      this.status === DELIVERY_STATUS_12 ||
      this.statusAddressNotSupported === DELIVERY_STATUS_4
    );
  }

  get statusDeliveryCompleted() {
    return this.status === DELIVERY_STATUS_5;
  }

  get statusDeliverySentBack() {
    return this.status === DELIVERY_STATUS_6;
  }

  get statusDeliveryCompletedOrSentBackOrLost() {
    return (
      this.statusDeliveryCompleted ||
      this.statusDeliverySentBack ||
      this.statusDeliveryLost
    );
  }

  get statusDeliveryStart() {
    return (
      this.status === DELIVERY_STATUS_4 ||
      this.statusAddressNotSupported === DELIVERY_STATUS_4
    );
  }

  get statusDeliveryLost() {
    return this.status === DELIVERY_STATUS_7;
  }

  // N14: 완료/반송/분실 처리는 됐지만 해당 완료위치 좌표가 저장되지 않은
  // "사각지대" 여부. true면 일반 위치보기/경로찾기 버튼 그룹을
  // fallback으로 계속 노출해야 한다 (원본 RN 앱과 동일 로직).
  get hasMissingCompletedLocation() {
    return (
      (this.statusDeliveryCompleted &&
        (!this.deliveryDoneLatitude || !this.deliveryDoneLongitude)) ||
      (this.statusDeliverySentBack &&
        (!this.deliverySentBackLatitude || !this.deliverySentBackLongitude)) ||
      (this.statusDeliveryLost &&
        (!this.deliveryLostLatitude || !this.deliveryLostLongitude))
    );
  }

  get statusDeliveryPostponed() {
    return this.status === DELIVERY_STATUS_12;
  }

  get statusDeliveryWaiting() {
    return (
      this.status === DELIVERY_STATUS_3 || this.status === DELIVERY_STATUS_8
    );
  }

  get statusPickup() {
    return (
      this.status === DELIVERY_STATUS_1 ||
      this.statusAddressNotSupported === DELIVERY_STATUS_1
    );
  }

  get statusPickupCompleted() {
    // TODO: 리스트에서 수거완료탭에 있을 경우 수거완료로 표시
    return this.status === DELIVERY_STATUS_2;
  }

  get statusString() {
    if (this.addressNotSupported) {
      switch (this.status) {
        case DELIVERY_STATUS_5:
          return "배송완료(배송불가)";
        case DELIVERY_STATUS_6:
          return "반송완료(배송불가)";
        case DELIVERY_STATUS_7:
          return "분실완료(배송불가)";
        default:
          return "배송불가";
      }
    } else {
      switch (this.status) {
        case DELIVERY_STATUS_1:
          return "미수거";
        case DELIVERY_STATUS_2:
          return "수거완료";
        case DELIVERY_STATUS_3:
        case DELIVERY_STATUS_8:
          return "대기";
        case DELIVERY_STATUS_12:
          return "연기";
        case DELIVERY_STATUS_4:
          return "배송";
        case DELIVERY_STATUS_5:
          return "배송완료";
        case DELIVERY_STATUS_6:
          return "반송완료";
        case DELIVERY_STATUS_7:
          return "분실완료";
        case DELIVERY_STATUS_9:
          return "배송불가";
        default:
          return "";
      }
    }
  }

  get statusStringForReallocation() {
    switch (this.status) {
      case DELIVERY_STATUS_1:
        return "수거";
      case DELIVERY_STATUS_2:
        return "수거완료";
      case DELIVERY_STATUS_3:
      case DELIVERY_STATUS_4:
      case DELIVERY_STATUS_8:
      case DELIVERY_STATUS_12:
        return "배송";
      case DELIVERY_STATUS_5:
        return "배송완료";
      case DELIVERY_STATUS_6:
        return "반송완료";
      case DELIVERY_STATUS_7:
        return "분실완료";
      default:
        return "";
    }
  }

  get statusWaiting() {
    return (
      this.status === DELIVERY_STATUS_3 || this.status === DELIVERY_STATUS_8
    );
  }

  get totalProductName() {
    let productNames = [];

    if (this.productName) {
      let _productName = `${this.productName}${
        this.renderProductCount ? ` [${this.renderProductCount}개]` : ""
      }`;

      productNames.push(_productName);
    }

    if (this.gatheredDeliveries.length > 0) {
      this.gatheredDeliveries.forEach((delivery) => {
        let _productName = `${delivery.productName}${
          delivery.renderProductCount
            ? ` [${delivery.renderProductCount}개]`
            : ""
        }`;

        productNames.push(_productName);
      });
    }

    return productNames.join(";;");
  }

  get translatedOriginText() {
    return (
      this.translatedResultOpenai?.originText ||
      this.translatedResultPapago?.originText
    );
  }

  get translatedPlatform() {
    return this.etc4Obj?.translatedPlatform;
  }

  get translatedResult() {
    return this.etc4Obj?.translatedResult;
  }

  get translatedResultOpenai() {
    return (
      this.translatedResult?.openai || this.translatedResult?.OPENAI || null
    );
  }

  get translatedResultPapago() {
    return this.translatedResult?.papago || null;
  }

  get typeNormal() {
    return this.type === DELIVERY_TYPE_NORMAL;
  }

  get typePickupReturn() {
    return (
      this.type === DELIVERY_TYPE_PICKUP || this.type === DELIVERY_TYPE_RETURN
    );
  }
}
